export const ga4Event = (eventName, data) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': eventName,
    ...data
  })
};
